module.exports = __webpack_public_path__ + "static/media/SimpleBadOptimized.e78bb2cf.jp2";